import React, {useEffect, useRef} from 'react'

export default ({value, onChange, name = color}) => {
  const inputRef = useRef(null)

  useEffect(() => {
    jscolor.installByClassName('jscolor')
  }, [])

  // Sync incoming form state changes
  useEffect(() => {
    const input = inputRef.current
    if (input && input.jscolor && value) {
      if (input.jscolor.toString() !== value) {
        input.jscolor.fromString(value)
      }
    }
  }, [value])

  const handleChange = e => {
    e.preventDefault()
    onChange({[name]: e.target.value})
  }

  return (
    <input
      ref={inputRef}
      type='text'
      name={name}
      autoComplete='off'
      defaultValue={value || ''} // Use defaultValue instead of value
      className='input jscolor'
      onChange={handleChange}
      onBlur={handleChange}
    />
  )
}
